
import { apiClient } from "./apiClient";

export const SF_BOM_HINHTHUCNOPBOM_SELECT_BY_BOM = "sf_hinhthucnopbom/select_by_bom"
export const SF_BOM_HINHTHUCNOPBOM_SELECT_ALL = "sf_hinhthucnopbom/select_all"

export const hinhThucNopBomApi = {
    select_by_bom: (sf_bom_id: number) => apiClient.post(`${SF_BOM_HINHTHUCNOPBOM_SELECT_BY_BOM}?sf_bom_id=${sf_bom_id}`),
    selectAll: () => apiClient.post(SF_BOM_HINHTHUCNOPBOM_SELECT_ALL)
}